import React from 'react'
import { CardDataProvider } from '../components/CardDataContext.js';
import CreateBlog from '../components/CreateBlog.js';

const CreateBlogPage = () => {
  return (
    <CardDataProvider>
    <CreateBlog/>
    </CardDataProvider>

  )
}

export default CreateBlogPage